import React, { useEffect, useState } from "react";
import { getFirestore, collection, getDocs } from "firebase/firestore";
import app from "../../firebaseConfig";

const db = getFirestore(app);

// DARK THEME & LAYOUT STYLES
const pageStyle = {
  backgroundColor: "#1E1E1E",
  color: "#FFFFFF",
  minHeight: "100vh",
  padding: "30px 20px",
  fontFamily: "Arial, sans-serif",
};

const headerStyle = {
  fontSize: "2.2rem",
  margin: "0 0 10px 0",
  fontWeight: "bold",
};

const subHeaderStyle = {
  fontSize: "1.2rem",
  margin: "0 0 20px 0",
  color: "#BBBBBB",
};

const formStyle = {
  maxWidth: "1400px", // wide layout for the big form
  margin: "0 auto",
};

const cardStyle = {
  backgroundColor: "#2C2C2C",
  padding: "20px",
  borderRadius: "8px",
  marginBottom: "20px",
  border: "1px solid #3A3A3A",
  display: "flex",
  flexDirection: "column",
  gap: "10px",
  transition: "transform 0.2s",
};

const cardHeaderRowStyle = {
  display: "flex",
  alignItems: "center",
  gap: "20px",
};

const profilePicStyle = {
  width: "80px",
  height: "80px",
  borderRadius: "50%",
  objectFit: "cover",
  border: "2px solid #555",
};

const cardTitleStyle = {
  fontSize: "1.5rem",
  margin: 0,
  wordBreak: "break-word",
};

const labelStyle = {
  fontWeight: "bold",
  marginBottom: "5px",
  display: "block",
};

const readOnlyInputStyle = {
  width: "100%",
  padding: "10px",
  borderRadius: "4px",
  border: "1px solid #555",
  backgroundColor: "#3C3C3C",
  color: "#FFFFFF",
  marginBottom: "10px",
};

const investsListStyle = {
  listStyleType: "disc",
  paddingLeft: "20px",
  margin: 0,
};

const UsersManagement = () => {
  const [users, setUsers] = useState([]);

  // Replace placeholder logic with Firestore logic:
  const fetchUsers = async () => {
    try {
      // Reads from a 'users' collection in Firestore
      const usersColRef = collection(db, "users");
      const snapshot = await getDocs(usersColRef);
      const userData = [];

      snapshot.forEach((doc) => {
        // Merge doc.id if needed, or just doc.data() if your doc has all fields
        userData.push({ id: doc.id, ...doc.data() });
      });

      setUsers(userData);
    } catch (error) {
      console.error("Error fetching users from Firestore:", error);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  return (
    <div style={pageStyle}>
      <h1 style={headerStyle}>Users Management</h1>
      <p style={subHeaderStyle}>
        Displaying all users from Firestore, including their profile name, email,
        and invests.
      </p>

      {/* Large form that displays each user in a "card" */}
      <form style={formStyle}>
        {users.map((user) => (
          <div
            key={user.id}
            style={cardStyle}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "scale(1.02)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "scale(1)";
            }}
          >
            {/* User Header: Picture + Name */}
            <div style={cardHeaderRowStyle}>
              <img
                src={user.profilePic || "/path/to/fallback.png"}
                alt={`${user.name}'s profile`}
                style={profilePicStyle}
              />
              <h2 style={cardTitleStyle}>{user.name || "Unknown User"}</h2>
            </div>

            {/* User Email */}
            <div>
              <label style={labelStyle}>Email</label>
              <input
                type="text"
                value={user.email || ""}
                readOnly
                style={readOnlyInputStyle}
              />
            </div>

            {/* Invests */}
            <div>
              <label style={labelStyle}>Invests</label>
              {Array.isArray(user.invests) && user.invests.length > 0 ? (
                <ul style={investsListStyle}>
                  {user.invests.map((invest, idx) => (
                    <li key={idx}>{invest}</li>
                  ))}
                </ul>
              ) : (
                <p>No invests yet.</p>
              )}
            </div>
          </div>
        ))}
      </form>
    </div>
  );
};

export default UsersManagement;
